import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import styled from 'styled-components';

const ColorDiv = styled.div<{ isRed: boolean }>`
  color: ${(props) => (props.isRed ? props.theme.colors.error : props.theme.colors.success)};
`;

export const RedGreenOptions: React.FC<{
  isEnabled: boolean;
  activeIcon: IconDefinition;
  inactiveIcon: IconDefinition;
  type?: String;
}> = ({ isEnabled, activeIcon, inactiveIcon, type }) => (
  <ColorDiv isRed={isEnabled}>
    {isEnabled ? <FontAwesomeIcon icon={inactiveIcon} /> : <FontAwesomeIcon icon={activeIcon} />}
    <>
      {isEnabled ? ' Deactivate' : ' Activate'}
      {type ? ` ${type}` : ''}
    </>
  </ColorDiv>
);
